import React from 'react';

/**
 * Toggle switch for boolean columns (Visible / Published).
 * Renders a sliding pill switch plus a Yes/No label and calls
 * onChange(!checked) when clicked.
 */
export default function Toggle({ checked, onChange, disabled = false, title }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      className={`admin-toggle ${checked ? 'on' : 'off'}${disabled ? ' disabled' : ''}`}
      title={title || (checked ? 'Yes - click to switch to No' : 'No - click to switch to Yes')}
      onClick={() => {
        if (!disabled) onChange(!checked);
      }}
    >
      <span className="admin-toggle-track">
        <span className="admin-toggle-thumb" />
      </span>
      <span className="admin-toggle-text">{checked ? 'Yes' : 'No'}</span>
    </button>
  );
}
